<template>
	<div >
		<card style="height: 500px; overflow-y: auto; overflow-x: hidden">
			<!-- 部门客户管理 -->
			<div class="multiple" style="width: 100%">
				<Table :columns="department_columns" :data="datas" size="small" ref="table"
					:row-class-name="rowClassName">
					<template slot-scope="{ row }" slot="name">
						<span style="color:#63B3E6;cursor: pointer;" @click.stop="edit"
							:data-id="row.id">{{row.name}}</span>
					</template>
					<template slot-scope="{ row }" slot="make_state">
						<img v-for="(item, index) in row.make_state" style="width: 20px; margin-top: 5px" :src="item" />
						<div v-if="row.make_state.length == 0"></div>
					</template>
					<template slot-scope="{ row }" slot="entrust">
						<div v-for="(item,index) in row.entrust" style="margin: 3px 0" :key="index">
							{{item.content}}
							{{item.created_at}}
						</div>
						<div v-if="row.entrust.length == 0"></div>
					</template>
					<template slot-scope="{ row }" slot="loans_money">
						<span>{{row.loans_money/10000}}万</span>
					</template>
					<template slot-scope="{ row }" slot="operation">
						<div>
							<span class="icon iconfont"
								:class="{'icon-shangsuo': row.is_lock == 1, 'icon-jiesuo': row.is_lock == -1}"
								style="font-size: 30px; cursor: pointer;" @click.stop="lock" :data-id="row.id"></span>
							<div style="display: flex; flex-direction: column; align-items: center;">
								<span style="color: #63B3E6; cursor: pointer;" @click.stop="clickGiveOut"
									:data-id="row.id">重新分配</span>
								<span style="color: #FFB556; cursor: pointer;" @click.stop="addSea"
									v-if="row.collect_times > 3" :data-id="row.id">加入公海</span>
								<!--                            <span style="color: #FFB556; cursor: pointer;" @click.stop="addPool" v-else :data-id="row.id" >加入公共池</span>-->
							</div>
						</div>
					</template>
				</Table>
			</div>
			<div class="pager1">
				<Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
					:current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small"
					show-elevator />
			</div>
		</card>
		<!-- 编辑/新增客户 -->
		<div v-if="editDiv" style="background: #f9fafc;">
			<Modal v-model="editModal" width="95%" title="" footer-hide :styles="editModalStyle">
				<NewEditClue @reloadData="getList" @beforeOne="beforeEditOne" @nextOne="nextEditOne" :id="clientId"
					ref="NewEditClue">
				</NewEditClue>
			</Modal>
		</div>
		<!-- 添加跟进记录 -->
		<Modal v-model="modal" width="1200" footer-hide>
			<quickEditClue @quickEditClient="quickEditClient" @reloadData="getList" @beforeOne="beforeOne"
				@nextOne="nextOne" :id="addRecordId" ref="quickEditClue"></quickEditClue>
		</Modal>
	</div>
</template>
<script>
	import quickEditClue from './quickEditClue.vue'
	import EditClue from './EditClue.vue'
	import NewEditClue from './NewEditClue.vue'
	import {
		mapActions,
		mapGetters
	} from "vuex";
	import {
		getList,
		addSea,
		addPool,
		allUnlock,
		lock,
		giveOut,
		getCount,
		transferUser,
		getClickList
	} from '@/api/client'
	import {
		getUserList,
		getMyClientTips,
		getAnnounce,
		getTeamList,
		getDepartmentList,
	} from '@/api/user'
	import {
		getAllMediumCode
	} from "../../api/runSet";
	export default {
		name: "ClickJumpClient",
		components: {
			quickEditClue,
			EditClue,
			NewEditClue
		},
		props:['get_uid','client_type','start','is_redistribution','status','timePeriod','timeType','timePeriodDate','medium_code_id'],
		data() {
			return {
				clientTips: {
					title: '',
					clientId: 0,
					type: 0,
					name: '',
					plat_at: '',
				},
				editDiv: false,
				editModal: false,
				clientId: 0,
				pageSize: 10,
				pageSizeOpts: [10, 50, 100, 200, 500],
				addRecordId: 0,
				foldShow: false,
				modal: false, //添加跟进记录
				media: [], //媒体代码
				apply: [], //申请条件
				count: 0,
				page: 1,
				name: '',
				remark: '',
				datas:[],
				menu: 'team_all_client',
				department_columns: [{
						type: 'selection',
						width: 60,
						align: 'center'
					},
					{
						"title": "跟进人",
						"key": "follow_name",
						"width": 60,
					},
					{
						"title": "客户",
						"slot": "name",
						"width": 100
					},
					{
						"title": "手机",
						"key": "phone",
						"width": 100
					},
					{
						"title": "性别",
						"key": "sex_name",
						"width": 50,
					},
					{
						"title": "星级",
						"key": "start_name",
						"width": 60,
					},
					{
						"title": "状态",
						"key": "status_name",
						"width": 60
					},
					{
						"title": "需求额度",
						"slot": "loans_money",
						"width": 70,
					},
					{
						"title": "跟进记录",
						// "key": "entrust",
						slot: 'entrust',
						"width": 180
					},
					{
						"title": "媒体代码",
						"key": "media_name",
						"width": 80
					},
					{
						"title": "申请时间",
						"key": "applied_at",
						"width": 100,
					},
					{
						"title": "跟进时间",
						"key": "updated_at",
						"width": 100,
					}
				],
			}
		},
		watch: {
			status() {
				this.getList();
			},
			get_uid(){
				this.getList();
			},
			start(){
				this.getList();				
			},
			timePeriod(){
				this.getList();				
			},
			client_type(){
				this.getList();				
			},
			timeType(){
				this.getList();				
			},
			is_redistribution(){
				this.getList();				
			},
			timePeriodDate(){
				this.getList();	
			},
			medium_code_id(){
				this.getList();
			}
		},
		computed: {
			...mapGetters(['token']),
		},
		mounted: function() {
			this.loadData();
			this.getCount();
			this.getList();
		},
		created: function() { //这里是定时器

		},
		methods: {
			...mapActions([
				'handleLogOut',
				'getUserInfo',
			]),
			getparams() {},
			async getAnnounce() {
				let that = this;
				var data = {
					token: this.token
				};
				let res = await getAnnounce(that, data);
				if (res.code == 1) {
					that.announce = res.data.text;
				}
			},
			goToMyImportantClient() {
				this.$router.push({
					path: '/ImportantClient'
				})
			},
			async myTips() {
				let that = this;
				var data = {
					token: this.token
				};
				let res = await getMyClientTips(that, data);
				if (res.code == 1) {
					that.clientTipsModal = true;
					that.clientTips = res.data;
				}
			},
			rowClassName(row, index) {
				if (row.is_updated > 0) {
					return 'table-blue-row';
				} else {
					return 'table-black-row';
				}
			},
			changeSwitch(status) {
				this.screeningSwitch = status;
			},
			mySearch() {
				this.page = 1;
				this.menu = 'team_search';
				this.getList();
			},
			addRecordClick(e) {
				let id = e.currentTarget.dataset.id;
				this.oldDatas = this.datas;
				this.addRecordId = id;
				this.modal = true;
			},
			timePeriodDateChange(e) {
				this.timePeriodDate = e
			},
			applyTimeChange(e) {
				this.apply_time = e;
			},
			joinTimeChange(e) {
				this.join_time = e;
				this.getList();
			},
			async loadData() {
				let that = this;
				var data = {
					token: this.token,
					only_customer: 1
				};
				let res = await getAllMediumCode(that, data);
				if (res.code == 1) {
					that.categoryList = res.data.list;
				}
				var data = {
					token: that.token,
					getSelf: 1,
				};
				res = await getTeamList(that, data);
				if (res.code == 1) {
					that.userList = res.data.list;
					that.teamList = res.data.list;
				}
				res = await getDepartmentList(that, data);
				if (res.code == 1) {
					that.departmentList = res.data.list;
				}
			},
			async getCount() {
				let that = this;
				var data = {
					token: this.token
				};
				let res = await getCount(that, data);
				if (res.code == 1) {
					that.$Message.success('获取成功');
					that.countData = res.data;
				}
			},
			initSearch() {

				this.getList();
			},
			changeSize(e) {
				this.pageSize = e;
				this.getList();
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			async getList() {
				let that = this;
				var data = {};
				data.limit = this.pageSize;
				data.menu = this.menu;
				data.token = this.token;
				data.page = this.page;
				
				data.timePeriod = this.timePeriod;
				data.timePeriodDate = this.timePeriodDate;
				data.get_uid = this.get_uid;
				data.client_type = this.client_type;
				data.start = this.start;
				data.timeType = this.timeType;
				data.status = this.status;
				data.medium_code_id = this.medium_code_id;
				let res = await getClickList(that, data);
				that.datas = res.data.list;
				that.count = res.count;
				that.getUserInfo();
			},
			addClue() {
				let that = this;
				this.clientId = 0;
				this.editDiv = true;
				this.$nextTick(function() {
					that.oldDatas = that.datas;
					that.editModal = true;
				})
			},
			edit(e) {
				let that = this;
				let id = e.id || e.currentTarget.dataset.id;
				this.clientId = id;
				this.editDiv = true;
				this.$nextTick(function() {
					/*
					that.oldDatas = that.datas;
					that.editModal = true;
					*/

					this.$router.push({
						name: 'newEditClue',
						params: {
							id: id,
							data: that.datas
						}
					})

				})
			},
			handleCheckAll() {
				if (this.indeterminate) {
					this.checkAll = false;
				} else {
					this.checkAll = !this.checkAll;
				}
				this.indeterminate = false;

				if (this.checkAll) {
					for (let i in this.userList) {
						this.giveOutUid.push(this.userList[i].id);
					}
				} else {
					this.giveOutUid = [];
				}
			},
			checkAllGroupChange(data) {
				if (data.length === 3) {
					this.indeterminate = false;
					this.checkAll = true;
				} else if (data.length > 0) {
					this.indeterminate = true;
					this.checkAll = false;
				} else {
					this.indeterminate = false;
					this.checkAll = false;
				}
			},
			clickGiveOut(e) {
				let that = this;
				this.giveOutId = e.currentTarget.dataset.id;
				that.giveOutModal = true;
			},
			giveOut() {
				let that = this;
				let ids = that.giveOutId;
				let data = {
					ids: ids,
					uid: that.giveOutUid,
					token: that.token
				}
				that.throttle(async function() {
					let res = await giveOut(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.giveOutModal = false;
						that.getList();
					}
				}, 2000);
			},
			giveOutBatch() {
				let that = this;
				let selectTion = this.$refs['table'].getSelection();
				let ids = [];
				selectTion.forEach(function(e) {
					ids.push(e.id);
				})
				let data = {
					ids: ids,
					uid: that.giveOutUid,
					token: that.token
				}
				that.throttle(async function() {
					let res = await giveOut(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.giveOutModal = false;
						that.getList();
					}
				}, 2000);
			},
			transferBatch() {
				let that = this;
				let selectTion = this.$refs['table'].getSelection();
				let ids = [];
				selectTion.forEach(function(e) {
					ids.push(e.id);
				})
				let data = {
					ids: ids,
					uid: that.giveOutUid,
					token: that.token
				}
				that.throttle(async function() {
					let res = await transferUser(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.transferModal = false;
						that.getList();
					}
				}, 2000);
			},
			allUnlock() {
				let that = this;
				let selectTion = this.$refs['table'].getSelection();
				let ids = [];
				selectTion.forEach(function(e) {
					ids.push(e.id);
				})
				this.$Modal.confirm({
					title: '确认批量解锁吗？',
					onOk: async () => {
						let res = await allUnlock(that, {
							token: that.token,
							ids: ids
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							//that.getList();
						}
					}
				})
			},
			addPoolBatch() {
				let that = this;
				let selectTion = this.$refs['table'].getSelection();
				let ids = [];
				selectTion.forEach(function(e) {
					ids.push(e.id);
				})
				this.$Modal.confirm({
					title: '确认批量加入公共池吗？',
					onOk: async () => {
						let res = await addPool(that, {
							token: that.token,
							id: ids
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					}
				})
			},
			addSea(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				this.$Modal.confirm({
					title: '确认加入公海吗？',
					onOk: async () => {
						let res = await addSea(that, {
							token: that.token,
							id: id
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					}
				})
			},
			addPool(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				this.$Modal.confirm({
					title: '确认加入公共池吗？',
					onOk: async () => {
						let res = await addPool(that, {
							token: that.token,
							id: id
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					}
				})
			},
			async getTipsList(e) {
				let that = this;
				var data = {};
				data.menu = e.currentTarget.dataset.type;
				data.token = this.token;
				data.limit = 10;
				let res = await getList(that, data);
				that.datas = res.data.list;
			},
			async lock(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				let res = await lock(that, {
					token: that.token,
					id: id
				});
				if (res.code == 1) {
					that.$Message.success(res.msg);
					that.getList();
				}
			},
			quickEditClient() {
				this.clientId = this.addRecordId;
				this.addRecordId = 0;
				this.modal = false;
				this.editDiv = true;
				this.$nextTick(function() {
					this.editModal = true;
				})
			},
			beforeEditOne() {
				let that = this;
				let item = that.findBeforeArr(that.oldDatas, 'id', that.clientId);
				this.$refs.NewEditClue.phoneShow = false;
				if (item == false) {
					that.$Message.error('此页没有更多了');
					return;
				}
				that.clientId = item.id;
			},
			nextEditOne() {
				let that = this;
				let item = that.findNextArr(that.oldDatas, 'id', that.clientId);
				this.$refs.NewEditClue.phoneShow = false;
				if (item == false) {
					that.$Message.error('此页没有更多了');
					return;
				}
				that.clientId = item.id;
			},
			beforeOne() {
				let that = this;
				let item = that.findBeforeArr(that.oldDatas, 'id', that.addRecordId);
				this.$refs.quickEditClue.$refs.AddRecord.phoneShow = false;
				if (item == false) {
					that.$Message.error('此页没有更多了');
					return;
				}
				that.addRecordId = item.id;
			},
			nextOne() {
				let that = this;
				let item = that.findNextArr(that.oldDatas, 'id', that.addRecordId);
				this.$refs.quickEditClue.$refs.AddRecord.phoneShow = false;
				if (item == false) {
					that.$Message.error('此页没有更多了');
					return;
				}
				that.addRecordId = item.id;
			}
		}
	}
</script>
<style scoped lang="less">
	/*栅格表开始*/
	.selectdiv .panel-body {
		padding: 20px 10;
		width: 100%;
		display: inline-block;
	}

	.selectdiv .btn {
		border-radius: 2px;
		margin: 5px 5px;
	}

	.team_btn1_rf {
		margin-top: 5px;
	}

	.rili_out {
		height: 36px;
		float: right;
		position: relative;
	}

	.rili_out .main_data {
		position: absolute;
		left: 0;
		top: 40px;
		z-index: 99;
		background: #ffffff;
		padding: 10px;
		border-radius: 4px;
		border: 1px #dddddd solid;
	}

	.rili_out .prompt {
		position: absolute;
		right: 4px;
		top: 4px;
		width: 8px;
		height: 8px;
		background: red;
		border-radius: 50%;
		border: 1px #ffffff solid;
	}

	.rili_out .btn_closerl {
		position: absolute;
		right: -10px;
		top: -10px;
		cursor: pointer;
	}

	#lk_content .callrecord {
		min-width: 1400px;
	}

	.callrecord-top {
		color: #FFFFFF;
		background-color: #db5a63;
	}

	#lk_content {
		width: 100%;
	}

	.callrecord .acco {
		cursor: pointer;
		color: red;
	}

	.callrecord .next2 {
		cursor: pointer;
		color: #8B0000;
	}

	#lk_content .callrecord-top .tit7 {
		width: 300px;
	}

	#lk_content .callrecord-top .tit15 {
		width: 120px;
	}

	#lk_content .callrecord-top .tit16 {
		width: 120px;
	}
</style>
<style scoped lang="less">
	.form-list .info-inline .name {
		float: left;
		line-height: 38px;
		background: #f0f0f0;
		border-right: 1px solid #ddd;
		padding: 0 18px;
		border-top-left-radius: 4px;
		border-bottom-left-radius: 4px;
	}

	.form-list {
		width: 100%;
		display: inline-block;
		clear: both;
		padding: 8px 0;
	}

	.form-list .info-inline {
		width: 16%;
		height: 40px;
		float: left;
		margin: 7px .5%;
	}

	.form-list .bor-al,
	.form-list .bor-at {
		border: 1px solid #ddd;
		border-radius: 4px;
		width: 49%;
		float: left;
	}

	.form-list .bor-al,
	.form-list .bor-at {
		border: 1px solid #ddd;
		border-radius: 4px;
		width: 49%;
		float: left;
	}

	.form-list .info-inline .right {
		overflow: auto;
		position: relative;
	}

	.form-list .mar-let {
		margin-left: 2%;
	}

	.hong {
		color: #F56171;
		font-weight: bold;
		cursor: pointer;
	}

	.lan {
		color: #124386;
		font-weight: bold;
		cursor: pointer;
	}

	.sousuo {
		width: 100%;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	/deep/ .ivu-modal-content {
		background-color: #f9fafc;
	}

	/deep/ .ivu-table-header thead tr th {
		text-align: center !important;
	}

	/deep/ .ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	/deep/ .ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}

	.count_tips {
		color: rgb(0, 0, 0);
		justify-content: center !important;
		background: rgb(229, 245, 253);
		width: 1400px;
		margin: 0 auto;
		/* padding: 5px; */
		line-height: 35px;
		height: 35px;
	}

	.count_tips_img {
		width: 15px;
		height: 15px;
		vertical-align: middle;
		margin-right: 5px;
		margin-bottom: 3px;
	}

	.announce_div {
		position: relative;
		background-color: #F2F2F2;
		color: #E8410B;
		margin-bottom: 20px;
	}

	.announce_img {
		position: absolute;
		left: 4px;

		img {
			width: 20px;
			height: 20px;
			margin-top: 5px;
		}
	}

	.announce_area {
		margin-left: 25px;
		overflow: hidden;

		marquee {
			margin-top: 5px;
		}
	}

	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #ff6699;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}

	/deep/ .client_name {
		display: inline-block;
		margin: 0 4px;
		color: #85c7ff;
	}
</style>
